import React from "react";
import { AbsoluteFill, useCurrentFrame, interpolate } from "remotion";

// 效果 39: 烟雾效果
export const SmokeEffect: React.FC = () => {
  const frame = useCurrentFrame();
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#1a1a2e",
        justifyContent: "center",
        alignItems: "flex-end",
        paddingBottom: 200,
      }}
    >
      {Array.from({ length: 10 }, (_, i) => {
        const delay = i * 10;
        const currentFrame = Math.max(0, frame - delay);
        const y = interpolate(currentFrame, [0, 90], [0, -400], {
          extrapolateRight: "clamp",
        });
        const x = Math.sin(currentFrame * 0.1 + i) * 50;
        const size = interpolate(currentFrame, [0, 90], [50, 150], {
          extrapolateRight: "clamp",
        });
        const opacity = interpolate(currentFrame, [0, 45, 90], [0, 0.6, 0], {
          extrapolateRight: "clamp",
        });
        
        return (
          <div
            key={i}
            style={{
              position: "absolute",
              width: size,
              height: size,
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              borderRadius: "50%",
              left: `calc(50% + ${x}px)`,
              top: `calc(100% - 200px + ${y}px)`,
              transform: "translate(-50%, -50%)",
              opacity,
              filter: "blur(20px)",
            }}
          />
        );
      })}
    </AbsoluteFill>
  );
};

// 效果 40: 水波纹
export const WaterRipple: React.FC = () => {
  const frame = useCurrentFrame();
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#0a1628",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {Array.from({ length: 8 }, (_, i) => {
        const delay = i * 10;
        const currentFrame = Math.max(0, frame - delay);
        const size = interpolate(currentFrame, [0, 60], [50, 500], {
          extrapolateRight: "clamp",
        });
        const opacity = interpolate(currentFrame, [0, 60], [1, 0], {
          extrapolateRight: "clamp",
        });
        
        return (
          <div
            key={i}
            style={{
              position: "absolute",
              width: size,
              height: size,
              borderRadius: "50%",
              border: "3px solid rgba(78, 205, 196, 0.8)",
              opacity,
              boxShadow: `
                0 0 20px rgba(78, 205, 196, 0.5),
                inset 0 0 20px rgba(78, 205, 196, 0.3)
              `,
            }}
          />
        );
      })}
    </AbsoluteFill>
  );
};

// 效果 41: 棱镜效果
export const PrismEffect: React.FC = () => {
  const frame = useCurrentFrame();
  const rotation = frame * 2;
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#000",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: 300,
          height: 300,
          position: "relative",
          transform: `rotate(${rotation}deg)`,
        }}
      >
        {Array.from({ length: 7 }, (_, i) => {
          const hue = i * 51.4; // 360/7
          const angle = (i * 360) / 7;
          
          return (
            <div
              key={i}
              style={{
                position: "absolute",
                width: 200,
                height: 10,
                background: `linear-gradient(90deg, 
                  transparent,
                  hsl(${hue}, 100%, 50%),
                  transparent
                )`,
                left: "50%",
                top: "50%",
                transformOrigin: "0 0",
                transform: `rotate(${angle}deg) translateX(-100px)`,
                filter: "blur(2px)",
              }}
            />
          );
        })}
      </div>
    </AbsoluteFill>
  );
};

// 效果 42: 全息效果
export const HologramEffect: React.FC = () => {
  const frame = useCurrentFrame();
  const scanLine = interpolate(frame, [0, 60], [0, 720], {
    extrapolateRight: "clamp",
  });
  const glitch = Math.random() > 0.95 ? 5 : 0;
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#000",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          fontSize: 100,
          fontWeight: "bold",
          color: "#00ffff",
          textShadow: `
            0 0 10px #00ffff,
            0 0 20px #00ffff,
            0 0 40px #00ffff
          `,
          transform: `translateX(${glitch}px)`,
          opacity: 0.8,
        }}
      >
        HOLO
      </div>
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: 2,
          backgroundColor: "rgba(0, 255, 255, 0.5)",
          top: scanLine,
          boxShadow: "0 0 10px rgba(0, 255, 255, 0.8)",
        }}
      />
      {Array.from({ length: 20 }, (_, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            width: "100%",
            height: 1,
            backgroundColor: "rgba(0, 255, 255, 0.1)",
            top: i * 36,
          }}
        />
      ))}
    </AbsoluteFill>
  );
};
